import { formValidationProps, useFormValidation } from "@/components/organisms/mixins/form-validation.mixin";
import { isMagasinBascule } from "@/utils/magasin";


export const newsLettersSelectorProps = () => ({
  magasins: {
    type: Array,
    required: true
  },
  clientNewsLetters: {
    type: Array,
    required: true
  },
  error: {
    type: Object,
    required: false,
    default: null
  },
  ...formValidationProps()
})
export const newsLettersSelectorEmits = () => ([
  "save"
])

export const useNewsLetterSelector = (props, context) => {
  const {
    v$,
    isSuccess,
    isLoadingComputed
  } = useFormValidation(props)

  const selectedProposals = ref([])
  const selectedMines = ref([])
  const newsLettersOrigin = ref([])
  const newsLetters = ref([])

  const proposed = computed(() => {
    return props.magasins
      .filter(magasin => !newsLetters.value.some(mag => mag.id === magasin.id) && !isMagasinBascule(magasin)).map(mag => {
        return {
          id: mag.id,
          name: mag.attributes.magasin,
          cp: mag.attributes.cp
        };
      });
  })

  const init = () => {
    newsLettersOrigin.value = props.clientNewsLetters.map((mailing) => {
      const magasin = props.magasins.find(mag => mag.id === mailing.attributes.id_magasin.toString());
      return {
        id: mailing.attributes.id_magasin.toString(),
        name: magasin ? magasin.attributes.magasin : '',
        cp: magasin ? magasin.attributes.cp : '',
        idMailing: mailing.id
      };
    });
    newsLetters.value = newsLettersOrigin.value;
  }
  const addToNewsletters = () => {
    newsLetters.value = newsLetters.value.concat(
      props.magasins
        .filter(mag => selectedProposals.value.includes(mag.id))
        .map(mag => {
          return {
            id: mag.id,
            name: mag.attributes.magasin,
            cp: mag.attributes.cp
          }
        })
    );
  }
  const removeFromNewsletters = () => {
    newsLetters.value = newsLetters.value.filter(mag => !selectedMines.value.includes(mag.id));
  }
  const save = () => {
    const toDelete = newsLettersOrigin.value.filter((magasin) => {
      return !newsLetters.value.some(mag => mag.id === magasin.id);
    });
    const toAdd = newsLetters.value.filter((magasin) => {
      return !newsLettersOrigin.value.some(mag => mag.id === magasin.id);
    });

    context.emit("save", { toDelete, toAdd });
  }

  return {
    v$,
    isSuccess,
    isLoadingComputed,
    selectedMines,
    selectedProposals,
    newsLetters,
    newsLettersOrigin,
    proposed,
    save,
    init,
    addToNewsletters,
    removeFromNewsletters
  }
}
